import { defaultSettings, type FeatureSettings, type Profile } from '../types';

export const bundledProfiles: Profile[] = [
    {
        slug: 'standard',
        name: 'Standard',
        settings: defaultSettings(),
    },
    {
        slug: 'visual',
        name: 'Visual',
        settings: {
            ...defaultSettings(),
            fontSize: 2,
            highContrast: true,
            highlightLinks: true,
            largeCursor: true,
            focusIndicators: true,
        },
    },
    {
        slug: 'blind',
        name: 'Blind',
        settings: {
            ...defaultSettings(),
            skipToContent: true,
            focusIndicators: true,
            reduceMotion: true,
            keyboardNavigation: true,
        },
    },
    {
        slug: 'motor',
        name: 'Motor',
        settings: {
            ...defaultSettings(),
            fontSize: 1,
            textSpacing: true,
            largeCursor: true,
            keyboardNavigation: true,
            focusIndicators: true,
            reduceMotion: true,
        },
    },
    {
        slug: 'cognitive',
        name: 'Cognitive',
        settings: {
            ...defaultSettings(),
            fontSize: 1,
            textSpacing: true,
            reduceMotion: true,
            readingMode: true,
        },
    },
    {
        slug: 'dyslexia',
        name: 'Dyslexia',
        settings: {
            ...defaultSettings(),
            fontSize: 1,
            textSpacing: true,
            readingMode: true,
            highlightLinks: true,
        },
    },
];

export function profileBySlug(
    slug: string,
    profiles: Profile[] = bundledProfiles,
): Profile | undefined {
    return profiles.find((profile) => profile.slug === slug);
}

export function mergeSettings(
    settings: Partial<FeatureSettings>,
): FeatureSettings {
    return { ...defaultSettings(), ...settings };
}
